import { createStore } from "vuex"

import createPersistedState from "vuex-persistedstate";
import state from "./state.js";
import actions from "./actions.js";
import * as getters from "./getters.js";
import * as mutations from "./mutations.js";

export default createStore({
  plugins: [createPersistedState()],
  state,
  actions,
  getters,
  mutations
});
